import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navBarHolder" }
const _hoisted_2 = { class: "navBarBack" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/AvailabilityPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Availability")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/BookingPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Booking")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/ContactPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Contact")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/FeaturesPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Features")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/PhotosPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Photos")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/SpecialsPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Specials")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/TariffsPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Tariffs")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "routerLinkStyle",
        to: "/EditDataPage"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Edit Data")
        ]),
        _: 1
      })
    ])
  ]))
}